import { CognitoAppAttribute } from '@app/types'
import { Menu, type MenuProps, useMantineTheme } from '@mantine/core'
import { IconGridDots } from '@tabler/icons-react'
import { filter, map } from 'lodash'
import { useSession } from 'next-auth/react'
import { type FC, useMemo } from 'react'

const apps: Record<string, { url: string; label: string }> = {
  [CognitoAppAttribute.DPP]: {
    label: 'Denver Preschool Program',
    url: `${process.env.NEXT_PUBLIC_DPP_URL}/login?sso=1`
  },
  [CognitoAppAttribute.WF]: {
    label: 'CDEC - Workforce Grants',
    url: `${process.env.NEXT_PUBLIC_WF_URL}/login?sso=1`
  }
}

export const AppSelector: FC<MenuProps> = (props) => {
  const theme = useMantineTheme()
  const { data } = useSession()
  const userApps = useMemo(() => filter(data?.user.apps, (app) => app !== CognitoAppAttribute.COUPK), [data?.user.apps])

  return userApps.length ? (
    <Menu
      offset={0}
      position='bottom'
      transitionProps={{
        transition: 'pop',
        duration: 200
      }}
      {...props}
    >
      <Menu.Target>
        <IconGridDots
          color={theme.colors['navy'][6]}
          size='32'
        />
      </Menu.Target>
      <Menu.Dropdown>
        {map(userApps, (app) => {
          const userApp = apps[app]

          return userApp ? (
            <Menu.Item
              component='a'
              fw='bold'
              key={app}
              href={userApp.url}
              target={app}
            >
              {userApp.label}
            </Menu.Item>
          ) : null
        })}
      </Menu.Dropdown>
    </Menu>
  ) : null
}
